// Vocab year group configuration — single source of truth for all vocab games.
// Tier 10 is a virtual "11+ Learning" range group (covers tiers 5–9 in the data file).
// All other tiers map 1:1 to rows in vocabularyByYearGroup.json.

// Highest tier shown in any year-group dropdown (tier 12 "Beyond NC" is kept in data but hidden from UI).
export const MAX_DISPLAY_TIER = 11;

export const YEAR_OPTIONS = [
  { tier: 0, label: "Reception" },
  { tier: 1, label: "Year 1" },
  { tier: 2, label: "Year 2" },
  { tier: 3, label: "Year 3" },
  { tier: 4, label: "Year 4" },
  { tier: 5, label: "Year 5" },
  { tier: 6, label: "Year 6" },
  { tier: 7, label: "Year 7" },
  { tier: 8, label: "Year 8" },
  { tier: 9, label: "Year 9" },
  { tier: 10, label: "11+ Lower", startTier: 5, endTier: 7 },
  { tier: 11, label: "11+ Higher", startTier: 8, endTier: 9 },
  { tier: 12, label: "Beyond NC" },
];

// Pre-filtered list for all dropdowns — excludes Beyond NC and any future tiers above MAX_DISPLAY_TIER.
export const DISPLAY_YEAR_OPTIONS = YEAR_OPTIONS.filter(opt => opt.tier <= MAX_DISPLAY_TIER);

// Maps a difficulty_tier from localStorage to the nearest vocab tier.
// Both systems now share the same numbering (0=Reception, 1=Year1 … 9=Year9, 10=11+Learning, 11=Beyond NC).
// Higher comprehension tiers (12+) cap at Year 9.
export function mapToNearestTier(rawTier) {
  const t = parseInt(rawTier, 10);
  if (isNaN(t) || t < 0) return 0;
  if (t <= 11) return t;
  return 9;
}

// Returns the human-readable year group label for a data tier number.
export function tierLabel(tier) {
  const opt = YEAR_OPTIONS.find((o) => o.tier === tier);
  return opt ? opt.label : `Tier ${tier}`;
}

// Returns the tier number(s) to filter by for a given YEAR_OPTIONS entry.
// For virtual groups returns { startTier, endTier }; for real tiers returns { tier }.
export function getTierFilter(selectedTier) {
  const opt = YEAR_OPTIONS.find((o) => o.tier === selectedTier);
  if (opt?.startTier !== undefined) {
    return { startTier: opt.startTier, endTier: opt.endTier };
  }
  return { tier: selectedTier };
}

// Filters an in-memory word array by the selected tier (handles virtual groups).
export function filterWordsByTier(words, selectedTier) {
  const opt = YEAR_OPTIONS.find((o) => o.tier === selectedTier);
  if (opt?.startTier !== undefined) {
    return words.filter(
      (w) => w.tier >= opt.startTier && w.tier <= opt.endTier,
    );
  }
  return words.filter((w) => w.tier === selectedTier);
}
